"use strict";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { slideDown, slideUp } from "slide-anim";

gsap.registerPlugin(ScrollTrigger);
const mediaQuery = matchMedia("screen and (min-width: 768px)");

const circles = document.querySelectorAll(".dandi-policy-table__circles");
circles.forEach((circle) => {
  gsap.to(circle, {
    scrollTrigger: {
      trigger: circle,
      start: "top 80%",
      end: "bottom",
      toggleClass: {
        targets: circle,
        className: "is-active",
      },
      once: true,
    },
  });
});
const accordionTrigger = document.querySelectorAll(".dandi-action-item");
changeMediaQuery(mediaQuery);
// ウィンドウサイズが変更されても実行されるように
mediaQuery.addListener(changeMediaQuery);
function changeMediaQuery(mq) {
  if (mq.matches) {
  } else {
    for (let i = 0; i < accordionTrigger.length; i++) {
      // トリガーを押した時のアクション
      let accordionTargetisOpened = false;
      accordionTrigger[i].addEventListener("click", (e) => {
        let currentElement = e.currentTarget;

        if (accordionTargetisOpened) {
          //トリガーの'is-active'クラスを削除
          currentElement.classList.remove("is-active");

          accordionTargetisOpened = false;
        } else {
          //トリガーの'is-active'クラスを追加
          currentElement.classList.add("is-active");

          accordionTargetisOpened = true;
        }
      });
    }
  }
}
